(function () {
  function initYoutubeLazyLoad() {
    document.addEventListener(
      'click',
      function (e) {
        const trigger = e.target.closest('[ecom-modal-source]');
        if (!trigger) return;

        const targetSelector =
          trigger.getAttribute('ecom-modal-source');
        if (!targetSelector) return;

        const container =
          document.querySelector(targetSelector);
        if (!container) return;

        const iframe = container.querySelector('iframe');
        if (!iframe) return;

        if (!iframe.src && iframe.dataset.src) {
          iframe.src = iframe.dataset.src;
        }
      },
      true
    );
  }

  document.addEventListener(
    'DOMContentLoaded',
    initYoutubeLazyLoad
  );
})();
